import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getAccountScopeUserSettings } from 'owa-session-store';
import saveWin32Style from './mutators/saveWin32Style';
import { WIN32_STYLE_ENABLED_SETTING_NAME } from './constants';

/**
 * Seeds the Win32 style enabled flag from the primed boot setting.
 *
 * Called once at boot. After this the local store is the single source of truth
 * for the session, so an in-session Save is never overwritten by the boot source.
 */
export default function initializeWin32StyleStore(): void {
    const primeSettings = getAccountScopeUserSettings(
        getGlobalSettingsAccountMailboxInfo()
    )?.PrimeSettings;
    const item = primeSettings?.Items?.find(
        setting =>
            typeof setting.Id === 'string' &&
            setting.Id.toLowerCase() === WIN32_STYLE_ENABLED_SETTING_NAME
    );
    saveWin32Style(item?.Value?.[0]?.value === 'true');
}
